import { css } from 'styled-components';
import { PaymentPlanProps } from './models';
import { expandedBottomHeight, paymentPlanSizes } from './stylesConsts';

const mobileAnimations = css`
  transition: all 0.3s ease-in-out;

  > .container > .bottom-section {
    // Drawer for animation
    transition: all 0.3s ease-in-out;
  }

  &.expanded {
    height: ${paymentPlanSizes.height};

    > .container > .bottom-section {
      height: ${expandedBottomHeight};
      visibility: visible;
    }
  }

  &.collapsed {
    height: ${paymentPlanSizes.mobileHeight};

    > .container > .bottom-section {
      height: 0;
      visibility: hidden;
    }
  }
`;

const animations = css`

  > .container {
    > .top-section > .payments-amount {
      // Drawer for animation
      transition: all 0.5s ease-in-out;
    }

    > .bottom-section {
      // Drawer for animation
      transition: all 0.3s ease-in-out;
    }
  }


  &.expanded > .container {
    > .top-section {
      > .payments-amount {
        font-size: 40px;
        line-height: 40px;
      }
    }

    > .bottom-section {
      height: ${expandedBottomHeight};
      visibility: visible;
    }
  }


  &.collapsed > .container {
    > .top-section {
      > .payments-amount {
        font-size: 56px;
        line-height: 56px;
      }
    }

    > .bottom-section {
      visibility: hidden;
    }
`;

const borderPlaceHolder = css`
  border: 4px solid transparent;
`;

const loadingStyle = css`
  cursor: progress;
  ${borderPlaceHolder};

  &:hover {
    ${borderPlaceHolder};
  }
`;

const skeletonStyle = css`
  pointer-events: none;
  ${borderPlaceHolder};

  &:hover {
    ${borderPlaceHolder};
  }
`;

export const PaymentPlan = css<PaymentPlanProps>(
  ({ theme, isSelected, isLoading, isSkeleton }) =>
    css`
      box-sizing: border-box;
      cursor: ${isSelected ? 'initial' : 'pointer'};
      overflow: hidden;
      max-width: ${paymentPlanSizes.maxWidth};
      height: ${paymentPlanSizes.height};
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      background: ${theme.colors.white};
      box-shadow: 0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1);
      border-radius: 16px;
      ${borderPlaceHolder};

      &.expanded {
        // Add extra space for selected plan
        // to enable plan border expand
        border: 4px solid ${theme.colors.primaryBright} !important;
      }

      ${isLoading && loadingStyle};
      ${isSkeleton && skeletonStyle};

      > .container {
        padding: 6px 15px;
        overflow: hidden;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        justify-content: center;

        @media only screen and ${theme.device.max.mobileXL} {
          justify-content: start;
        }

        > .top-section {
          color: ${theme.colors.primaryBackground};
          text-align: center;
          width: 100%;
          margin: auto 0;

          > .payments-amount {
            color: inherit;
            font-weight: 700;
            font-size: 40px;
            line-height: 40px;
            margin: 0;
            padding: 0;
            margin-bottom: 2px;
          }

          > .monthly-payments {
            color: inherit;
            font-weight: 400;
            font-size: 14px;
            line-height: 21px;
            margin: 0;
          }

          > .monthly-payment-rate {
            font-weight: 700;
            font-size: 21px;
            line-height: 32px;
            color: inherit;
            margin: 0;

            > .sign {
              font-size: 14px;
              vertical-align: text-bottom;
            }
          }
        }

        > .bottom-section {
          display: flex;
          justify-content: space-between;
          font-size: ${theme.font.size.small};
          font-weight: ${theme.font.weight.light};
          width: 100%;
          border-top: 1px solid ${theme.colors.lightGray};
          height: 0;
          margin: 1px 0 0;
          overflow: hidden;
          visibility: hidden;
          padding-top: 5px;
          gap: 10px;

          > .column {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-top: 4px;

            > .title {
              padding: 0;
              font-weight: 400;
              font-size: 14px;
              line-height: 14px;
              color: ${theme.colors.lightGray};
              margin: 0;
              margin-bottom: 2px;
            }

            > .amount-txt {
              color: ${theme.colors.primaryBackground};
              text-align: left;

              > .finance {
                font-weight: 400;
                font-size: 12px;
                margin: 0;

                > .number {
                  font-weight: 600;
                  font-size: 14px;
                }
              }
            }

            > .total-amount-text {
              text-align: right;
            }
          }
        }
      }

      @media only screen and ${theme.device.max.mobileXL} {
        ${mobileAnimations};
      }

      @media only screen {
        ${animations};
      }


    }
    `
);
